/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { CSSProperties, FunctionComponent } from "react";

export const SvgBranch: FunctionComponent<{ style?: CSSProperties, className?: string }> = ({ style, className }) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="m13.75 4.5a2.5 2.5 0 1 0 -3.612 2.22729c-.28961.89728-1.20294 1.19532-2.90021 1.53248a12.43352 12.43352 0 0 0 -1.48779.36938v-3.84106a2.5 2.5 0 1 0 -2 0v6.42376a2.5 2.5 0 1 0 2 0v-.21185c0-.31836.40332-.48535 1.87744-.77832 1.67529-.33337 4.12409-.82855 4.55109-3.40485a2.50027 2.50027 0 0 0 1.57147-2.31683zm-10.5-2a1.5 1.5 0 1 1 1.5 1.5 1.50164 1.50164 0 0 1 -1.5-1.5zm3 11a1.5 1.5 0 1 1 -1.5-1.5 1.50164 1.50164 0 0 1 1.5 1.5zm5-7.5a1.5 1.5 0 1 1 1.5-1.5 1.50164 1.50164 0 0 1 -1.5 1.5z" />
    </svg>
  );
};
